import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7805481c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "refund-approval-content"
};
const _hoisted_2 = {
  class: "refund-header"
};
const _hoisted_3 = {
  class: "refund-content"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "select-content"
};
const _hoisted_6 = {
  class: "refund-block-wrap"
};
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"title-content\" data-v-7805481c><div class=\"title\" data-v-7805481c>退款申请</div><div class=\"status pass\" data-v-7805481c>已通过</div></div><div class=\"time-content\" data-v-7805481c><div class=\"label\" data-v-7805481c>申请提交于</div><div class=\"content\" data-v-7805481c>2023-10-01 18:00:11</div></div><div class=\"info-title-content\" data-v-7805481c><div class=\"line\" data-v-7805481c></div><div class=\"title\" data-v-7805481c>审批详情</div></div>", 3);
const _hoisted_11 = {
  class: "info-content"
};
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"flex-list\" data-v-7805481c><div class=\"label\" data-v-7805481c>申请人</div><div class=\"content\" data-v-7805481c>张三</div></div><div class=\"flex-list\" data-v-7805481c><div class=\"label\" data-v-7805481c>申请产品</div><div class=\"content\" data-v-7805481c>张三</div></div><div class=\"flex-list\" data-v-7805481c><div class=\"label\" data-v-7805481c>三方订单号</div><div class=\"content\" data-v-7805481c>张三</div></div><div class=\"flex-list\" data-v-7805481c><div class=\"label\" data-v-7805481c>内购ID</div><div class=\"content\" data-v-7805481c>张三</div></div><div class=\"flex-list\" data-v-7805481c><div class=\"label\" data-v-7805481c>商品名称</div><div class=\"content\" data-v-7805481c>张三</div></div><div class=\"flex-list\" data-v-7805481c><div class=\"label\" data-v-7805481c>价格</div><div class=\"content\" data-v-7805481c> 18 <span data-v-7805481c>CNY</span></div></div><div class=\"flex-list red\" data-v-7805481c><div class=\"label\" data-v-7805481c>退款金额</div><div class=\"content\" data-v-7805481c> 18 <span data-v-7805481c>CNY</span></div></div><div class=\"flex-list\" data-v-7805481c><div class=\"label\" data-v-7805481c>退款原因</div><div class=\"content\" data-v-7805481c>未成年退款</div></div>", 8);
const _hoisted_20 = {
  class: "flex-list"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "客诉截图", -1));
const _hoisted_22 = {
  class: "content"
};
const _hoisted_23 = {
  class: "flex-list"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info-title-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "line"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "审批记录")], -1));
const _hoisted_25 = {
  class: "table-content"
};
const __default__ = {
  name: 'RefundApproval'
};
import RefundBlock from '@/views/orderManage/refundApproval/components/refundBlock.vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const columns = [{
      title: '节点名称',
      dataIndex: 'nodeName',
      key: 'nodeName'
    }, {
      title: '审批人',
      dataIndex: 'approver',
      key: 'approver'
    }, {
      title: '审批结果',
      dataIndex: 'approvalResult',
      key: 'approvalResult'
    }, {
      title: '审批意见',
      dataIndex: 'approvalOpinion',
      key: 'approvalOpinion'
    }, {
      title: '审批时间',
      dataIndex: 'approvalTime',
      key: 'approvalTime'
    }];
    const activeKey = ref('1');
    const tableData = [{
      nodeName: '节点1',
      approver: '张三',
      approvalResult: '通过',
      approvalOpinion: '同意',
      approvalTime: '2023-10-01 18:00:11'
    }, {
      nodeName: '节点2',
      approver: '李四',
      approvalResult: '通过',
      approvalOpinion: '同意',
      approvalTime: '2023-10-01 18:00:11'
    }];
    const changeType = () => {};
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_tabs, {
        activeKey: activeKey.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => activeKey.value = $event),
        onChange: changeType
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "我的申请"
        }), _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "我的审批"
        })]),
        _: 1
      }, 8, ["activeKey"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_a_select, {
        placeholder: "产品名称"
      }), _createVNode(_component_a_select, {
        placeholder: "审批状态"
      })]), _createElementVNode("div", _hoisted_6, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, item => {
        return _createVNode(RefundBlock, {
          key: item
        });
      }), 64))])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createVNode(_component_a_image, {
        src: require('@/assets/imgs/logo.png')
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_23, [_createVNode(_component_a_button, null, {
        default: _withCtx(() => [_createTextVNode("撤回申请")]),
        _: 1
      })])]), _hoisted_24, _createElementVNode("div", _hoisted_25, [_createVNode(_component_a_table, {
        columns: columns,
        "data-source": tableData,
        pagination: false
      })])])])]);
    };
  }
});